import TemplatesListComponent from 'src/components/features/superAdmin/templatesListComponent';

const ListTemplatePage = () => <TemplatesListComponent />;

export default ListTemplatePage;
